import { useEffect, useState } from "react";

// react-router-dom components
import { Link, useNavigate } from "react-router-dom";

// @mui material components
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import GoogleIcon from "@mui/icons-material/Google";
import CallIcon from "@mui/icons-material/Call";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";

// Images

import bg from "assets/images/bg2.png";
import { Mail } from "@mui/icons-material";
import { setTransparentNavbar } from "context";
import { navbarIconButton } from "examples/Navbars/DashboardNavbar/styles";

import { useMaterialUIController, setOpenConfigurator } from "context";
import { Icon, IconButton, InputAdornment, Menu } from "@mui/material";

import NotificationItem from "examples/Items/NotificationItem";

import * as Yup from "yup";
import { useFormik } from "formik";
import {
  useLazyGetProfileQuery,
  usePostLogInMutation,
} from "../../../services/auth";
import {
  getFromStorage,
  removeFromStorage,
  setToStorage,
  STORAGE_KEYS,
} from "../../../helpers";
import ShowToast from "components/MDToast";
import { setCredentials } from "reducers/authSlice";
import { useAppDispatch } from "hooks/store";
import Loader from "helpers/constants/Loader";
import { isNumber } from "utils/validations";
import { setDirection } from "context";
import { useLanguageContext } from "context/Language";
import useTranslation from "hooks/Translation";

export default function SignInPage() {
  const navigate = useNavigate();
  const t = useTranslation();
  const currentLang = getFromStorage(STORAGE_KEYS.language);
  const [loginMutation, { isLoading }] = usePostLogInMutation();
  const [getUser] = useLazyGetProfileQuery();
  const { changeLanguage } = useLanguageContext();
  const usedispatch = useAppDispatch();
  const [rememberMe, setRememberMe] = useState(false);
  const [controller, dispatch] = useMaterialUIController();
  const { darkMode, openConfigurator } = controller;
  const [isPhone, setIsPhone] = useState(false);
  const [langMenu, setLangMenu] = useState(false);
  const handleOpenLangMenu = (event) => setLangMenu(event.currentTarget);
  const handleCloseLangMenu = () => setLangMenu(false);
  const [showPassword, setShowPassword] = useState(false);
  const deviceToken = getFromStorage(STORAGE_KEYS.fcmToken);
  const handleConfiguratorOpen = () =>
    setOpenConfigurator(dispatch, !openConfigurator);

  const iconsStyle = ({
    palette: { dark, white, text },
    functions: { rgba },
  }) => ({
    color: () => {
      let colorValue = "#fff";

      if (setTransparentNavbar) {
        colorValue = "#fff";
      }

      return colorValue;
    },
  });

  const getUserDetails = async () => {
    const token = getFromStorage(STORAGE_KEYS.token);
    try {
      const result = await getUser({}).unwrap();
      if (result?.status === 200 && token) {
        usedispatch(
          setCredentials({
            user: result?.data,
            token: token,
          })
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const LanguageMenu = () => (
    <Menu
      anchorEl={langMenu}
      anchorReference={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      open={Boolean(langMenu)}
      onClose={handleCloseLangMenu}
      sx={{ mt: 2 }}
    >
      <NotificationItem
        onClick={() => {
          window.location.reload();
          setToStorage(STORAGE_KEYS.language, "en");
          changeLanguage("en");
        }}
        // icon={<Icon>email</Icon>}
        title="English"
      />
      <NotificationItem
        onClick={() => {
          window.location.reload();
          setToStorage(STORAGE_KEYS.language, "ar");
          setDirection(dispatch, "rtl");
          changeLanguage("ar");
        }}
        // icon={<Icon>email</Icon>}
        title="Arabic"
      />
      <NotificationItem
        onClick={() => {
          window.location.reload();
          setToStorage(STORAGE_KEYS.language, "ru");
          changeLanguage("ru");
        }}
        // icon={<Icon>podcasts</Icon>}
        title="Russian"
      />
    </Menu>
  );

  const handleChangePhone = (phone, country) => {
    formik.setFieldValue("phone", phone?.replace(country.dialCode, ""));
    formik.setFieldValue(
      "countryCode",
      country?.dialCode.includes("+") ? "" : "+" + country?.dialCode
    );
  };

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      remember: false,
      phone: "",
      countryCode: "+971",
    },
    validationSchema: Yup.object({
      remember: Yup.boolean(),
      email: !isPhone
        ? Yup.string()
            .required(t.error.emailReq)
            .matches(
              /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
              t.error.validEmail
            )
        : Yup.string().notRequired(),
      password: !isPhone
        ? Yup.string().label("Password").required(t.error.passReq)
        : Yup.string().notRequired(),
      phone: !isPhone
        ? Yup.string().notRequired()
        : Yup.string()
            .required("Phone number is required")
            .min(6, "Minimum 6 digits are required")
            .max(16, "Maximum 16 digits are required"),
    }),
    onSubmit: async (values) => {
      formik.setSubmitting(true);
      let emailBody = {
        email: values.email,
        password: values.password,
        device_token: deviceToken,
      };

      let phoneBody = {
        phone_no: values.phone,
        country_code: values.countryCode,
        device_token: deviceToken,
      };

      let body = isPhone ? phoneBody : emailBody;
      console.log(body, "body---body");

      try {
        const response = await loginMutation(body).unwrap();
        console.log(response, "resss=======");
        // return;
        if (response?.status === 200) {
          ShowToast(response?.message || "");
          if (!isPhone) {
            setToStorage(STORAGE_KEYS.token, response?.data?.token || "");
            usedispatch(
              setCredentials({
                user: response?.data,
                token: response?.data?.token || "",
              })
            );
            getUserDetails();
            if (formik.values.remember) {
              setToStorage(STORAGE_KEYS.credentials, JSON.stringify(body));
            } else {
              removeFromStorage(STORAGE_KEYS.credentials);
            }
            if (response?.data?.profile_status === 5) {
              navigate("/dashboard", { replace: true });
            } else if (response?.data?.profile_status === 2) {
              const state = {
                key: response?.data?.otp_verification
                  ? response?.data?.email
                  : response?.data?.phone_no,
                page: "login",
                type: response?.data?.otp_verification ? "email" : "phone",
                ...(response?.data?.phone_no_verification
                  ? { countryCode: response?.data?.countryCode }
                  : {}),
              };
              navigate("/authentication/profile-setup", {
                state: state,
                replace: true,
              });
            }
          } else {
            navigate("/otp-verify", {
              state: {
                page: "login",
                type: "phone",
                key: values.phone,
                countryCode: values.countryCode,
                replace: true,
              },
            });
          }
        } else {
          ShowToast(response?.message || "Something went wrong", "error");
        }
      } catch (error) {
        ShowToast(error?.data?.message || "", "error");
      }
    },
  });

  const handleSetRememberMe = () => setRememberMe(!rememberMe);

  useEffect(() => {
    const data = getFromStorage(STORAGE_KEYS.credentials);
    if (data) {
      const rememberData = JSON.parse(`${data}`);
      formik.setFieldValue("password", rememberData?.password);
      formik.setFieldValue("email", rememberData?.email);
      formik.setFieldValue("remember", true);
    }
    // eslint-disable-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BasicLayout>
      <Grid
        container
        className="signin-container"
        sx={{ overflow: "hidden", minHeight: "100vh" }}
      >
        {/* Image Section */}
        <Grid
          item
          xs={0}
          md={6}
          sx={{
            display: { xs: "none", md: "block" },
            position: "relative",
            background: "black",
            height: "100vh",
          }}
        >
          <MDBox
            sx={{
              position: "absolute",
              backgroundColor: "rgba(0,0,0,0.7)",
              borderRadius: 2,
              margin: 5,
              padding: 1,
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
              cursor: "pointer",
            }}
            onClick={handleOpenLangMenu}
          >
            <MDBox sx={{ display: "flex", alignItems: "center" }}>
              <IconButton
                size="small"
                disableRipple
                color="inhewhiterit"
                sx={navbarIconButton}
                aria-controls="notification-menu"
                aria-haspopup="true"
                variant="contained"
              >
                <Icon sx={iconsStyle}>language</Icon>
              </IconButton>
              <MDTypography
                color="white"
                pr={1}
                sx={{ fontSize: 14, cursor: "pointer" }}
              >
                {currentLang === "en"
                  ? "En"
                  : currentLang === "ru"
                  ? "Ru"
                  : "Ar"}
              </MDTypography>
            </MDBox>
          </MDBox>
          {LanguageMenu()}

          <img
            src={bg}
            alt="Sign In"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              marginTop: "-2px",
            }}
          />
        </Grid>

        {/* Form Section */}
        <Grid
          item
          xs={12}
          md={6}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            position: "relative",
            alignItems: "center",
            px: { xs: 4, sm: 8 },
          }}
        >
          {/* <Card> */}
          <MDBox sx={{ maxWidth: 500, width: "100%" }} pt={5}>
            <MDBox
              // variant="gradient"
              // bgColor="#2B604C"
              borderRadius="lg"
              // coloredShadow="info"
              mx={2}
              // mt={-3}
              // p={2}
              mb={1}
              textAlign="center"
            >
              <MDTypography variant="h4" fontWeight="medium" mt={1}>
                {t.main.signToSura}
              </MDTypography>
            </MDBox>
            <MDBox pt={2} pb={3} px={3}>
              <form onSubmit={formik.handleSubmit}>
                {isPhone ? (
                  <MDBox mb={2}>
                    <MDTypography variant="subtitle2" className="custom_label">
                      {t.main.phone} *
                    </MDTypography>
                    <PhoneInput
                      country={"ae"}
                      placeholder="0 (000) 000-000"
                      enableSearch={false}
                      inputStyle={{
                        width: "100%",
                        backgroundColor: "transparent",
                        height: "45px",
                      }}
                      dropdownStyle={{}}
                      containerClass={`phone-input-container ${
                        formik.touched.phone && formik.errors.phone
                          ? "phone-input-error"
                          : ""
                      }`}
                      value={formik.values.countryCode + formik.values.phone}
                      onChange={(phone, country) =>
                        handleChangePhone(phone, country)
                      }
                      // onBlur={formik.handleBlur}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault(); // Prevent default behavior (form submission)
                          formik.handleSubmit(); // Manually submit the form
                        }
                      }}
                    />
                    {formik.touched.phone && formik.errors.phone ? (
                      <MDTypography variant="body1" className="err_msg">
                        {formik.touched.phone && formik.errors.phone}
                      </MDTypography>
                    ) : (
                      ""
                    )}
                  </MDBox>
                ) : (
                  <MDBox mb={2}>
                    <MDTypography variant="subtitle2" className="custom_label">
                      {t.main.email} *
                    </MDTypography>
                    <MDInput
                      className="text_field"
                      type="email"
                      placeholder={t.main.email}
                      fullWidth
                      name="email"
                      id="email"
                      error={formik.touched.email && formik.errors.email}
                      onChange={(val) => {
                        if (
                          val.target.value === " " ||
                          val.target.value === "."
                        ) {
                        } else {
                          formik.handleChange(val);
                        }
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.email}
                      helperText={formik.touched.email && formik.errors.email}
                    />
                  </MDBox>
                )}

                {!isPhone ? (
                  <MDBox mb={2}>
                    <MDTypography variant="subtitle2" className="custom_label">
                      {t.auth.password} *
                    </MDTypography>
                    <MDInput
                      className="text_field"
                      placeholder={t.auth.password}
                      fullWidth
                      hiddenLabel
                      name="password"
                      id="password"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.password}
                      type={showPassword ? "text" : "password"}
                      helperText={
                        formik.touched.password && formik.errors.password
                      }
                      error={formik.touched.password && formik.errors.password}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment className="eye_btn" position="end">
                            <IconButton
                              aria-label="toggle password visibility"
                              onClick={() => setShowPassword(!showPassword)}
                              onMouseDown={() => setShowPassword(!showPassword)}
                              edge="end"
                            >
                              {showPassword ? (
                                <Visibility />
                              ) : (
                                <VisibilityOff />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </MDBox>
                ) : null}

                {!isPhone ? (
                  <MDBox
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <MDBox display="flex" alignItems="center" ml={-1}>
                      <Switch
                        checked={formik.values.remember}
                        onChange={formik.handleChange}
                        name="remember"
                        color="success"
                      />
                      <MDTypography
                        variant="button"
                        fontWeight="regular"
                        onClick={handleSetRememberMe}
                        sx={{
                          cursor: "pointer",
                          userSelect: "none",
                          ml: -1,
                          fontSize: "14px",
                          fontWeight: "400",
                          letterSpacing: "0.3px",
                          lineHeight: "1.2",
                        }}
                      >
                        &nbsp;&nbsp;{t.auth.remember}
                      </MDTypography>
                    </MDBox>

                    <MDTypography
                      component={Link}
                      to="/authentication/forgot-password"
                      variant="button"
                      fontWeight="regular"
                      textGradient
                    >
                      {t.auth.forgotPassword}?
                    </MDTypography>
                  </MDBox>
                ) : null}

                <MDBox mt={4} mb={1}>
                  <MDButton
                    // onClick={() => {
                    //   isPhone
                    //     ? navigate("/otp-verify", { state: "phone" })
                    //     : navigate("/dashboard");
                    // }}
                    variant="gradient"
                    color="success"
                    fullWidth
                    type="submit"
                  >
                    {t.auth.login}
                  </MDButton>
                </MDBox>
              </form>
              {/* <Grid
                container
                spacing={3}
                justifyContent="center"
                sx={{ mt: 1, mb: 1 }}
              >
                <Grid item xs={12}>
                  {isPhone ? (
                    <MDBox sx={{ justifyContent: "center", display: "flex" }}>
                      <MDTypography
                        onClick={() => setIsPhone(false)}
                        variant="button"
                        fontWeight="regular"
                        sx={{ textDecoration: "underline", cursor: "pointer" }}
                      >
                        Login with Email
                      </MDTypography>
                    </MDBox>
                  ) : (
                    <MDBox sx={{ justifyContent: "center", display: "flex" }}>
                      <MDTypography
                        onClick={() => setIsPhone(true)}
                        variant="button"
                        fontWeight="regular"
                        sx={{ textDecoration: "underline", cursor: "pointer" }}
                      >
                        Login with Phone
                      </MDTypography>
                    </MDBox>
                  )}
                </Grid>
       
              </Grid> */}

              <MDBox mt={3} mb={1} textAlign="center">
                <MDTypography fontWeight="regular" variant="button">
                  {t.auth.dontHave}{" "}
                  <MDTypography
                    component={Link}
                    to="/authentication/sign-up"
                    variant="button"
                    color="#2B604C"
                    fontWeight="medium"
                  >
                    {t.auth.signUp}
                  </MDTypography>
                </MDTypography>
              </MDBox>
            </MDBox>
          </MDBox>
          {/* </Card> */}
          <MDBox
            sx={{
              position: "absolute",
              bottom: 0,
              display: "flex",
              width: "100%",
              gap: 2,
              padding: "0px 10px 10px 10px",
              justifyContent: "center",
            }}
          >
            <MDTypography variant="caption" fontWeight="medium" color="text">
              &copy; {new Date().getFullYear()}, Sura Trade
            </MDTypography>

            <MDTypography
              variant="caption"
              fontWeight="medium"
              color="text"
              sx={{ textDecoration: "underline", cursor: "pointer" }}
              onClick={() => navigate("/privacy-policy")}
            >
              Privacy Policy
            </MDTypography>
            <MDTypography
              variant="caption"
              fontWeight="medium"
              color="text"
              sx={{ textDecoration: "underline", cursor: "pointer" }}
              onClick={() => navigate("/terms")}
            >
              Terms and Conditions
            </MDTypography>
            <MDTypography
              variant="caption"
              fontWeight="medium"
              color="text"
              sx={{ textDecoration: "underline", cursor: "pointer" }}
              onClick={() => navigate("/about")}
            >
              About Us
            </MDTypography>
          </MDBox>
        </Grid>
      </Grid>
      <Loader loading={isLoading} />
    </BasicLayout>
  );
}
